import {Navigation} from '../../components/Navigation'
import useMeta from '../../hook/useMeta'
import PaymentCalender from './layouts/PaymentCalender'
import {PageLink} from '../../_metronic/layout/core'

const analyticPaymentCalenderPageBreadcrumb: PageLink[] = [
  {
    title: 'Analytics',
    path: '/analytics',
    isActive: false,
  },
]

const AnalyticPaymentCalenderPage = () => {
  useMeta('Payment Schedule Analytics Page')

  return (
    <Navigation
      baseUrl={'/analytics/payment-schedule'}
      breadcrumbs={analyticPaymentCalenderPageBreadcrumb}
      navigationData={[
        {
          key: 'payment-calender',
          label: 'Payment Schedule',
          component: <PaymentCalender />,
        },
      ]}
    />
  )
}

export default AnalyticPaymentCalenderPage
